import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What are the benefits of custom LMS?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Custom Learning Management Systems (LMS) offer numerous benefits, some of them are as follows:</p>
                                    <ul>
                                        <li><strong>Modified to Your Requirements: </strong>Custom LMS can be created to match your explicit educational goals, content, and roadmaps.</li>
                                        <li><strong>Scalability: </strong>They can be expanded and nurtured with your organization, catering to more users and content as required.</li>
                                        <li><strong>Branding: </strong>Custom LMS permits you to align the platform with your branding and offer a reliable user experience.</li>
                                        <li><strong>Improved Features: </strong>You can mix progressive features, such as analytics, gamification, and social learning, to expand engagement and learning results.</li>
                                        <li><strong>Data Security: </strong>Custom LMS can be developed with strong security measures to shield sensitive educational data.</li>
                                        <li><strong>Flexibility: </strong>Custom LMS can be developed with strong security measures to shield sensitive educational data.</li>
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    What is the most effective feature of LMS?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>The usefulness of Learning Management Systems (LMS) contrasts depending on educational objectives, but one of the most influential aspects is often the capability to track and study learner development. This feature permits educators and administrators to:</p>
                                    <ul>
                                        <li>Manage learner engagement and accomplishment rates.</li>
                                        <li>Classify dominions where learners may be struggling.</li>
                                        <li>Examine the effectiveness of certain courses or content.</li>
                                        <li>Make data-oriented decisions for course enhancement.</li>
                                        <li>Offer custom-made learning experiences built on individual growth.</li>
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;